module.exports = __webpack_public_path__ + "img/lion_nine.901c70c5.jpg";